import { stationStates } from 'utils/constant/resources/stationResorces'

export const getStateName = (state: number): string | undefined =>
  state === null ? stationStates[0]?.label : stationStates[parseInt(state) + 1]?.label
